import B_Util from '../../../base/dev/util/B_Util';
import B_Define from '../../../base/dev/util/B_Define';
import B_World from '../../../base/dev/frame/B_World';
import B_Tick from '../../../base/dev/frame/B_Tick';
import R_State from '../model/R_State';
import R_Define from '../util/R_Define';
import R_Tick from './R_Tick';

import B_Grid from '../../../base/dev/child/grid/B_Grid';
import R_Bg from '../child/graphic/R_Bg';
import R_SpriteHero from '../child/graphic/R_SpriteHero';
import R_ImageGrid from '../child/image/R_ImageGrid';
import R_ImageObstacle from '../child/image/R_ImageObstacle';
import R_Solution from '../child/attr/R_Solution';
import R_Interpreter from '../util/R_Interpreter';
import R_Repeat from '../child/attr/R_Repeat';
import B_Variable from '../../../base/dev/child/graphic/B_Variable';
import R_VariableReal from '../child/attr/R_VariableReal';

const init = () => {
    return class R_World extends B_World {
        constructor(cm) {
            super(cm);

            this._runCnt = 0;

            // run 이벤트가 활성 상태인지
            this._isRun = false;

            // 기본으로 출력 될 히어로의 리소스 아이디
            this._defaultHeroId = R_Define.DEFAULT_HERO_ID;

            this.bg = [];

            this.initList(R_Define.LIST.slice(0));
            this.STATE = new R_State();

            this.CODMOS.loadTool();
            this.CODMOS.setSpriteSheet();

            this.INTERPRETER = new R_Interpreter(cm);

            this._objList = [];
        }

        /**
         * [ Function :: realod ]
         *
         * @DES :: 재시작
         * @O.P :: null
         */
        realod() {
            Object.values(this.LIST[B_Define.REAL_TYPE]).forEach((e) => {
                e._visible = false;
            });
            // 속도 초기화
            this.CODMOS.speed = R_Define.DEFAULT_SPEED;
            // 인터프리터 초기화
            this.INTERPRETER.end();
            this.INTERPRETER = new R_Interpreter(this.CODMOS);
            // run 이벤트 초기화
            clearInterval(this._runEvt);
            // State 초기화
            setTimeout(() => {
                this.STATE.renew();
            }, R_Define.TICK_TIME_INTERVAL);
        }

        /**
         * [ Function :: _gameEnd ]
         *
         * @DES :: 게임 종료 및 솔루션 처리
         * @O.P :: null
         */
        _gameEnd() {
            const { STATE } = this;
            let clearStatus = 'FAIL';

            const solutions = Object.values(this.LIST[B_Define.SOLUTION_TYPE]);

            if (
                !solutions.length
                || !solutions.some(e => !e.compare())
            ) {
                clearStatus = 'SUCCESS';
            }

            STATE.stop(
                B_Define.CLEAR_STATUS[clearStatus],
                B_Define.REASON[clearStatus],
                null
            );

            const pointObj = this.LIST[B_Define.VARIABLE_REAL_TYPE][R_Define.VARIABLES.POINT];
            let point = 0;
            if (pointObj) point = pointObj.getValue();

            this.CODMOS.onCanvasEvent(STATE.get(point));

            const [hero] = Object.values(this.LIST[R_Define.HERO_TYPE]);

            hero.clear();
        }

        /**
         * [ Function :: gameOver ]
         *
         * @DES :: 게임 오버
         * @O.P :: null
         */
        gameOver() {
            this.CODMOS.TOOL.onGameOver();

            this._gameEnd();
        }

        /**
         * [ Function :: setBG ]
         *
         * @DES :: 배경 설정 (변경)
         * @IP1 :: bg {string}
         * @IP2 :: cb {function}
         * @O.P :: null
         */
        setBG(bg, cb) {
            if (bg === 'random') {
                const bgSet = Object.keys(this.CODMOS._bgSet);
                const exce = bgSet.findIndex(e => e === this.CODMOS._nowBgSet);
                bg = bgSet[B_Util.getRandomInt(0, bgSet.length - 1, exce)];
            }
            Object.values(this.LIST[B_Define.BG_TYPE]).forEach(e => e._remove());
            this.CODMOS._nowBgSet = bg;
            this.CODMOS._bgSet[bg].bg.forEach((e, i) => {
                this.addBG({
                    ...e,
                    img: `${bg}_${i}`
                });
            });

            if (typeof cb === 'function') cb();
        }

        /**
         * [ Function :: addBG ]
         *
         * @DES :: 배경 추가
         * @IP1 :: obj {object}
         * @O.P :: null
         */
        addBG(obj) {
            const bg = new R_Bg({
                ...obj,
                cm: this.CODMOS,
                id: B_Util.getRandomID(B_Define.BG_TYPE),
                type: B_Define.BG_TYPE
            });

            this.bg.push(bg);
            this.addChild(bg._container);
        }

        /**
         * [ Function :: __run ]
         *
         * @DES :: run 이벤트 최초 형식 (차후 자동화 행성 개발 때 참고용으로 남겨둠)
         * @O.P :: null
         */
        __run() {
            const { STATE } = this;
            const { _lenX: gridDisX, column } = this[this._gridId];
            const gridDisX2 = Math.floor(gridDisX);

            // 배경 이동
            const func = async (bg) => {
                console.log('!', this.CODMOS.time, gridDisX, bg.speed, this.CODMOS.time / gridDisX / bg.speed);
                await Array(Math.ceil(bg._w)).fill(null).reduce(async (a) => {
                    await a;

                    return new Promise((resolve) => {
                        if (STATE.play) {
                            setTimeout(() => {
                                bg._pixelX--;
                                resolve();
                            }, this.CODMOS.time / gridDisX / bg.speed);
                        } else {
                            resolve();
                        }
                    });
                }, Promise.resolve);

                if (STATE.play) {
                    bg._pixelX = 0;
                    await func(bg);
                }
            };

            this.bg.forEach(func);

            // 오브젝트 이동
            const func2 = async (obj) => {
                let cnt = 0;
                await Array(Math.ceil(obj.pixelX)).fill(null).reduce(async (a) => {
                    await a;

                    return new Promise((resolve) => {
                        if (
                            STATE.play
                            && obj._visible
                        ) {
                            if (STATE.play) {
                                setTimeout(() => {
                                    obj._pixelX--;
                                    cnt++;
                                    if (cnt === gridDisX2) {
                                        obj._gridX--;
                                        const HERO = obj.checkUnderType(R_Define.HERO_TYPE);
                                        if (HERO) {
                                            this.CODMOS.WRAPPER.BlocklyManager.hit(obj._res);
                                            obj._remove();
                                        }
                                        cnt = 0;
                                    }
                                    resolve();
                                }, this.CODMOS.time / gridDisX);
                            } else {
                                resolve();
                            }
                        } else {
                            resolve();
                        }
                    });
                }, Promise.resolve);
            };

            Object.values(this.LIST[R_Define.HIT_ITEM_TYPE]).forEach(func2);

            // 깃발 이동
            const func3 = async (goal) => {
                let cnt = 0;
                await Array(goal._gridX).fill(null).reduce(async (a) => {
                    await a;

                    return new Promise((resolve) => {
                        if (STATE.play) {
                            setTimeout(() => {
                                goal._pixelX--;
                                cnt++;
                                if (cnt === gridDisX2) {
                                    goal._gridX--;
                                    const HERO = goal.checkUnderType(R_Define.HERO_TYPE);
                                    if (HERO) {
                                        STATE.stop(
                                            B_Define.CLEAR_STATUS.SUCCESS,
                                            B_Define.REASON.SUCCESS,
                                            goal
                                        );
                                        this.CODMOS.onCanvasEvent(STATE.get());
                                    }
                                    cnt = 0;
                                }
                                resolve();
                            }, this.CODMOS.time / gridDisX);
                        } else {
                            resolve();
                        }
                    });
                }, Promise.resolve);
            };

            Object.values(this.LIST[R_Define.GOAL_TYPE]).forEach(func3);
        }

        /**
         * [ Function :: _run ]
         *
         * @DES :: 달리기 이벤트
         * @O.P :: null
         */
        _run() {
            if (!this._isRun) {
                this._isRun = true;
                const { STATE } = this;
                const { _lenX: gridDisX, column } = this[this._gridId];

                const [hero] = Object.values(this.LIST[R_Define.HERO_TYPE]);

                // 만약 _repeat가 참일 경우
                if (this._repeat) {
                    // 객체 리스트를 gridX 순으로 정렬하여
                    this._objList.sort((a, b) => b.x - a.x);
                    // 가장 마지막 gridX 값 획득
                    const [{ x: lastX }] = this._objList;
                    // 에디터에서 지정 한 객체 세트 간 간격 + 마지막 gridX
                    this._repeat.lastX = lastX;
                    // 모든 객체를 this._repeat.interval만큼 뒤에 새로 생성
                    this._objList.forEach((e) => {
                        this.addObject({
                            ...e,
                            id: B_Util.getRandomID(),
                            x: e.x + this._repeat.interval
                        }, true);
                    });

                    if (
                        !this._repeat.noFlag
                        && this._repeat.isLast()
                    ) {
                        const id = B_Util.getRandomID();
                        this.addObject({
                            res: 'flag',
                            type: R_Define.GOAL_TYPE,
                            id,
                            x: this._repeat.lastX + this._repeat.interval + 1,
                            y: 8
                        }, true);
                    }

                    this._repeat.count++;
                }

                let movePx = 0;
                let isCalGridX = false;

                this._runEvt = setInterval(() => {
                    if (STATE.play) {
                        // 이동 간격
                        const MOVE_INTERVAL = R_Define.GET_TICK_MOVE_INTERVAL(gridDisX) * this.CODMOS.speed;

                        movePx += MOVE_INTERVAL;
                        let isGridMove = false;
                        let isGridOver = false;

                        // 절반이 넘었을 경우 그리드 이동 처리
                        if (!isCalGridX && movePx >= (gridDisX / 2)) {
                            isCalGridX = true;
                            isGridMove = true;
                        }

                        // 전체를 넘었을 경우 movePx 초기화
                        if (isCalGridX && movePx >= gridDisX) {
                            isGridOver = true;
                            isCalGridX = false;
                            movePx -= gridDisX;
                        }

                        // 배경 이동
                        this.bg.forEach((bg) => {
                            bg._pixelX -= MOVE_INTERVAL * bg.speed;
                            if (Math.abs(bg._pixelX) >= bg._w) {
                                if (bg.one) bg._remove();
                                else bg._pixelX = 0;
                            }
                        });

                        // 아이템 이동
                        Object.values(this.LIST[R_Define.HIT_ITEM_TYPE]).forEach((item) => {
                            item.moveToLeft(MOVE_INTERVAL);
                            if (isGridMove) {
                                item._gridX--;
                                if (
                                    item._gridX === column
                                    && item._rotate
                                    && !item._isRotate
                                ) {
                                    item.rotate();
                                }
                            }

                            if (item.isHitHero) { // 히어로 충돌 시 인터프리터 충돌 이벤트 호출
                                this.INTERPRETER.hit(item._res);
                                item._remove();
                            } else if (isGridOver && item._gridX < 1) { // 더 이상 화면에서 보이지 않을 때
                                item._remove();
                            }
                        });

                        // 깃발
                        Object.values(this.LIST[R_Define.GOAL_TYPE]).forEach((goal) => {
                            goal.moveToLeft(MOVE_INTERVAL);
                            if (isGridMove) {
                                goal._gridX--;
                                if (
                                    goal._gridX === column
                                    && goal._rotate
                                    && !goal._isRotate
                                ) {
                                    goal.rotate();
                                }
                            }
                            if (goal.isHitHero) { // 히어로 충돌 시 솔루션 처리
                                this._gameEnd();
                            } else if (isGridOver && goal._gridX < 1) { // 더 이상 화면에서 보이지 않을 때
                                goal._remove();
                            }
                        });

                        // 장애물
                        Object.values(this.LIST[R_Define.OBSTACLE_TYPE]).forEach((obstacle) => {
                            obstacle.moveToLeft(MOVE_INTERVAL);
                            if (isGridMove) {
                                obstacle._gridX--;
                                if (
                                    obstacle._gridX === column
                                    && obstacle._rotate
                                    && !obstacle._isRotate
                                ) {
                                    obstacle.rotate();
                                }
                            }

                            if (
                                !hero._isOnInvincible
                                && !obstacle._hit
                                && obstacle.isHitHero
                            ) { // 히어로 충돌 시 인터프리터에 장애물 충돌 이벤트 호출
                                obstacle._hit = true;
                                if (typeof this.INTERPRETER.hitObstacle === 'function') {
                                    this.INTERPRETER.hitObstacle();
                                }
                            } else if (isGridOver && obstacle._gridX < 1) { // 더 이상 화면에서 보이지 않을 때
                                obstacle._remove();
                            }
                        });

                        // 그리드 한 칸의 크기만큼 움직였을 때
                        if (isGridMove) {
                            this.runCnt++;

                            // 만약 1그리드 이상 이동 하였고, repeat 객체가 있을 경우
                            if (this._repeat && this.runCnt) {
                                if (this._repeat.isEnded(this.runCnt)) { // repeat 동작이 모두 완료 되었을 경우
                                    this._gameEnd();
                                } else if (
                                    !this._repeat.repeatEnded
                                    && !(this.runCnt % this._repeat.interval)
                                ) {
                                    // 모든 객체를 _repeatInterval만큼 뒤에 새로 생성
                                    this._objList.forEach((e) => {
                                        const obj = this.addObject({
                                            ...e,
                                            id: B_Util.getRandomID(),
                                            x: e.x + this._repeat.interval
                                        }, true);
                                        // 이전 그리드부터 오브젝트 생성 되기까지 사이에 왼쪽으로 움직인 만큼 객체 오른쪽으로
                                        obj.moveToRight(movePx);
                                    });

                                    if (
                                        !this._repeat.noFlag
                                        && this._repeat.isLast()
                                    ) {
                                        this.addObject({
                                            res: 'flag',
                                            type: R_Define.GOAL_TYPE,
                                            id: B_Util.getRandomID(),
                                            x: this._repeat.lastX + this._repeat.interval + 1,
                                            y: 8
                                        }, true);
                                    }

                                    this._repeat.count++;
                                }
                            }
                        }
                    } else {
                        // 게임 진행 중이 아니면 이벤트 종료
                        clearInterval(this._runEvt);
                    }
                }, R_Define.TICK_TIME_INTERVAL);
            }
        }

        // @OVERRIDING
        tick() {
            super.tick();
            R_Tick.tickSwal(this);
            B_Tick.tickVariableReload(this);
        }

        // @OVERRIDING
        addObject(obj, isRepeat) {
            super.addObject(obj); // [E]

            if (this._gridId && typeof obj.parent === 'undefined') obj.parent = this._gridId;

            let instance;
            switch (obj.type) {
                case B_Define.GRID_TYPE: {
                    this._gridId = obj.id;
                    instance = new B_Grid(obj);
                    break;
                }
                case R_Define.HERO_TYPE: {
                    const { defaultHeroSrc } = this.CODMOS.WRAPPER;
                    if (defaultHeroSrc) {
                        const findRes = Object.keys(this.CODMOS._sprite).find((key) => {
                            return this.CODMOS._sprite[key].src === defaultHeroSrc;
                        });
                        if (findRes) this._defaultHeroId = findRes;
                    }
                    instance = new R_SpriteHero({
                        ...obj,
                        res: this._defaultHeroId
                    });
                    break;
                }
                case R_Define.GOAL_TYPE: {
                    if (!isRepeat) this._objList.push(obj);
                    instance = new R_ImageGrid(obj);
                    break;
                }
                case R_Define.HIT_ITEM_TYPE: {
                    if (!isRepeat) this._objList.push(obj);
                    instance = new R_ImageGrid(obj);
                    break;
                }
                case R_Define.OBSTACLE_TYPE: {
                    if (!isRepeat) this._objList.push(obj);
                    instance = new R_ImageObstacle(obj);
                    break;
                }
                case R_Define.BLOCK_SOLUTION_TYPE:
                case R_Define.VARIABLE_SOLUTION_TYPE:
                case R_Define.INVENTORY_SOLUTION_TYPE: {
                    instance = new R_Solution(obj);
                    break;
                }
                case B_Define.VARIABLE_REAL_TYPE: {
                    instance = new R_VariableReal(obj);
                    break;
                }
                case B_Define.VARIABLE_TYPE: {
                    instance = new B_Variable(obj);
                    break;
                }
                // 해당 객체가 존재할 경우 GOAL_TYPE, HIT_ITEM_TYPE, OBSTACLE_TYPE 객체가 반복하여 계속 나옴.
                case R_Define.REPEAT_TYPE: {
                    this._repeat = new R_Repeat(obj);
                    break;
                }
                default: {
                    B_Util.print(B_Define.MESSAGE.NO_CHILD_TYPE);
                    return;
                }
            }

            if (instance && instance._container) {
                instance._setArea();
                instance._setPoint();

                if (obj.parent) this[obj.parent]._container.addChild(this[obj.id]._container);
                else this.addChild(this[obj.id]._container);

                return isRepeat ? instance : B_Util.getProtected(instance);
            }
        }

        // run 이벤트를 통해 움직인 그리드 수
        get runCnt() { return this._runCnt; }

        set runCnt(cnt) {
            const inteval = cnt - this._runCnt;
            if (inteval > 0) {
                Object.values(this.LIST[R_Define.HERO_TYPE])[0]._move();
            }
            this._runCnt = cnt;
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/frame/R_World.js